const EmployeeShifts = ({ employeeShifts }) => {

    let serverTotal = 0, bartenderTotal = 0, expoTotal = 0, hostTotal = 0, busserTotal = 0, totalTipOut = 0
    employeeShifts.forEach(i => {
        if (i.Title === "Server") {
            serverTotal += i.FinalTipOut
        } else if (i.Title === "Bartender") {
            bartenderTotal += i.FinalTipOut
        } else if (i.Title === "Expo") {
            expoTotal += i.FinalTipOut
        } else if (i.Title === "Host") {
            hostTotal += i.FinalTipOut
        } else if (i.Title === "Busser") {
            busserTotal += i.FinalTipOut
        }
    })

    totalTipOut = serverTotal + bartenderTotal + expoTotal + hostTotal + busserTotal

    return (
        <div>
        <p/>
        {serverTotal === 0?null:<div>Server TipOut: {Number(serverTotal.toFixed(2))}</div>}
        {bartenderTotal === 0?null:<div>Bartender TipOut: {Number(bartenderTotal.toFixed(2))}</div>}
        {expoTotal === 0?null:<div>Expo TipOut: {Number(expoTotal.toFixed(2))}</div>}
        {hostTotal === 0?null:<div>Host TipOut: {Number(hostTotal.toFixed(2))}</div>}
        {busserTotal === 0?null:<div>Busser TipOut: {Number(busserTotal.toFixed(2))}</div>}
        {totalTipOut === 0?null:<div><b>Total TipOut: {Number(totalTipOut.toFixed(2))}</b></div>}
        <p/>

        {employeeShifts.length !== 0?
            (
            <table className="table">
                <thead className="thead-dark">
                    <tr>
                        <th scope="col">Date</th>
                        <th scope="col"></th>
                        <th scope="col">Title</th>
                        <th scope="col">CCTip</th>
                        <th scope="col">Sushi Tip</th>
                        <th scope="col">Bar Tip</th>
                        <th scope="col">Host Tip</th>
                        <th scope="col">Expo Tip</th>
                        <th scope="col">Busser Tip</th>
                        <th scope="col">Final TipOut</th>
                        <th scope="col">Notes</th>
                    </tr>
                </thead>
                <tbody>
                {employeeShifts.map(i => (
                    <tr key={i.ID}>
                        <td><b>{i.Date}</b></td>{i.IsLunch?<td>Lunch</td>:<td>Dinner</td>}<td>{i.Title}</td>
                        {i.CCTip !== 0 ? <td>{Number((i.CCTip - i.CCTipFee).toFixed(2))}</td>:<td></td>}
                        {i.SushiTip !== 0 ? <td>{i.SushiTip}</td>:<td></td>}
                        {i.BarTip !== 0 ? <td>{i.BarTip}</td>:<td></td>}
                        {i.HostTip !== 0 ? <td>{i.HostTip}</td>:<td></td>}
                        {i.ExpoTip !== 0 ? <td>{i.ExpoTip}</td>:<td></td>}
                        {i.BusserTip !== 0 ? <td>{i.BusserTip}</td>:<td></td>}
                        {i.FinalTipOut !== 0 ? <td><b>{i.FinalTipOut}</b></td>:<td></td>}
                        {i.Notes !== null && i.Notes !== ""? <td>{i.Notes}</td>:<td></td>}
                    </tr>
                ))}
            </tbody>
            </table>):null}
        </div>
    )
}

export default EmployeeShifts